import React from "react";

interface MandatePaymentMethodProps {
	onClick: () => void;
	label: string;
	icon: string;
	loading?: boolean;
	open?: boolean;
	variant: "dark" | "light";
}

const MandatePaymentMethod = ({
	onClick,
	label,
	icon,
	loading,
	open,
	variant,
}: MandatePaymentMethodProps) => {
	return (
		<li
			{...{ onClick }}
			className={`p-4 rounded-md flex flex-row transition-all cursor-pointer items-center ${
				variant === "dark"
					? "bg-dark text-white"
					: "bg-gray-900 text-dark"
			}`}
		>
			<div className="flex flex-row flex-1">
				<div>
					<i className={`mr-4 ${icon}`}></i>
				</div>
				<strong className="mb-0">{label}</strong>
			</div>
			{loading ? (
				<span className="base-loader"></span>
			) : (
				<div>
					<i
						className={`fas fa-angle-right transition-all ${
							open && "transform rotate-90"
						}`}
					></i>
				</div>
			)}
		</li>
	);
};

MandatePaymentMethod.defaultProps = {
	variant: "dark",
};

export default MandatePaymentMethod;
